import React, { Component } from "react";

import WritingImage from "../../assets/images/2018/graphics/Writing.png";
import LogoImage from "../../assets/images/2018/Logo.png";
import { Button } from "../Controls";
import { Link } from "react-router";
import "./styles.less";
import texts from "../../assets/strings/details.js";

class MessageMobile extends Component {
  onChange(evt) {
    this.props.messageFieldOnChange(evt.target.value);
  }

  render() {
    let firstName = this.props.reducer.target.firstName[0].value,
      message = this.props.reducer.message,
      {
        isResponse,
        charity: { name }
      } = this.props.reducer;
    return (
      <div className="message mobile">
        <h1>{texts.message.h1}</h1>
        <p className="note">
          {isResponse
            ? texts.message.h3response.replace(/{{firstName}}/g, firstName)
            : texts.message.h3.replace(/{{firstName}}/g, firstName)}
        </p>
        <h4>{texts.message.placeholder}</h4>
        <textarea
          onChange={evt => this.onChange(evt)}
        />
        <img src={WritingImage} style={{ maxWidth: "60%", marginBottom: "40px" }} />
        <blockquote>
          <p
            className="quotation"
            dangerouslySetInnerHTML={{
              __html: texts.message.message
                .replace("{{firstName}}", firstName)
                .replace(
                  "{{message}}",
                  message ? message : texts.message.noMessage
                )
                .replace("{{charity}}", name)
            }}
          />
          <footer><img className="signature-logo" src={LogoImage} /></footer>
        </blockquote>
        <section className="controls">
          <Button large={true} accent={true}>
            <Link to="/details/target"> {texts.message.actions.prev} </Link>
          </Button>
          <Button large={true} primary={true}>
            <Link to="/payment"> {texts.message.actions.next} </Link>
          </Button>
        </section>
      </div>
    );
  }
}
export default MessageMobile;



// WEBPACK FOOTER //
// ./components/Message/MessageMobile.js